import { type ReactElement, type ReactNode } from "react";

import { type IconName } from "./Icon.tsx";

/** Um arquivo da lista de <Downloads>. */
export interface DownloadFile {
  name: string;
  href: string;
  size?: string;
  desc?: string;
  icon?: IconName | (string & {});
  featured?: boolean;
}

/** Uma versão do <Changelog>. */
export interface ChangelogEntry {
  v: string;
  date?: string;
  tag?: string;
  items?: ReactNode[];
}

import { Children, isValidElement } from "react";

import Icon from "./Icon.jsx";

// Blocos menores disponíveis em qualquer .mdx sem precisar de import.

// Parágrafo de abertura, maior que o corpo do texto.
//
// É um <div>, não um <p>: no MDX o conteúdo entre as tags já é parseado como
// parágrafo, então um <p> aqui aninharia <p> dentro de <p> — HTML inválido que
// o navegador "conserta" fechando o externo cedo e quebrando o layout. O CSS faz
// o parágrafo interno herdar a tipografia do lead.
export function Lead({ children }: { children?: ReactNode }) {
  return <div className="doc-lead">{children}</div>;
}

// Rótulo acima do <h1>, indicando a seção ("Começar", "IA", "Operação").
export function Eyebrow({ children }: { children?: ReactNode }) {
  return <div className="doc-eyebrow">{children}</div>;
}

export function Badge({ children, type = "beta" }: { children?: ReactNode; type?: string }) {
  return <span className={`doc-badge-${type}`}>{children}</span>;
}

// <Steps><Step title="Autentique"> … </Step></Steps>
export function Steps({ children }: { children?: ReactNode }) {
  const items = Children.toArray(children).filter((c): c is ReactElement<{ title?: ReactNode; children?: ReactNode }> =>
    isValidElement(c)
  );
  return (
    <ol className="doc-steps">
      {items.map((child, i) => (
        <li key={i} className="doc-step">
          <span className="doc-step-n mono">{i + 1}</span>
          <div className="doc-step-body">
            {child.props.title && <div className="doc-step-title">{child.props.title}</div>}
            {child.props.children}
          </div>
        </li>
      ))}
    </ol>
  );
}

export function Step({ children }: { title?: ReactNode; children?: ReactNode }) {
  return <>{children}</>;
}

// <Downloads files={[{ name, desc, size, href, icon, featured }]} />
export function Downloads({ files = [] }: { files?: DownloadFile[] }) {
  return (
    <div className="dl-list">
      {files.map((f) => (
        <a key={f.href} className={`dl-card ${f.featured ? "featured" : ""}`} href={f.href} download>
          <div className="dl-card-icon">
            <Icon name={f.icon || "file-json"} size={20} />
          </div>
          <div className="dl-card-body">
            <div className="dl-card-name mono">{f.name}</div>
            <div className="dl-card-desc">{f.desc}</div>
          </div>
          {f.size && <div className="dl-card-size mono">{f.size}</div>}
          <Icon name="download" size={16} />
        </a>
      ))}
    </div>
  );
}

// <Changelog entries={[{ v, date, tag, items: [] }]} />
export function Changelog({ entries = [] }: { entries?: ChangelogEntry[] }) {
  return (
    <div className="cl-feed">
      {entries.map((e) => (
        <div key={e.v} className="cl-entry">
          <div className="cl-side">
            <span className="cl-v mono">{e.v}</span>
            <span className="cl-date">{e.date}</span>
            {e.tag && <span className="cl-tag">{e.tag}</span>}
          </div>
          <ul className="cl-items">
            {(e.items ?? []).map((it, j) => (
              <li key={j}>{it}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
